export default __webpack_public_path__ + "static/media/sample-zip.574cfd3c.zip";